import { useAuth } from "../lib/auth";

export default function Profile() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className="p-6 md:p-8 max-w-2xl" data-testid="profile-page">
      <div className="overline mb-1">// Compte utilisateur</div>
      <h1 className="text-3xl font-bold tracking-tight mb-6" style={{fontFamily:"'Work Sans', sans-serif"}}>Profil</h1>

      <div className="bg-white border border-gray-200 p-8">
        <div className="flex items-center gap-4 mb-6 pb-6 border-b border-gray-200">
          <div className="w-16 h-16 bg-[#002FA7] text-white flex items-center justify-center text-2xl font-semibold">
            {user.name.charAt(0).toUpperCase()}
          </div>
          <div>
            <div className="text-xl font-semibold" data-testid="profile-name">{user.name}</div>
            <div className="text-sm text-gray-600" data-testid="profile-email">{user.email}</div>
          </div>
        </div>
        <div className="space-y-3">
          <div className="border-b border-gray-100 pb-2">
            <div className="overline">ID utilisateur</div>
            <div className="text-xs text-gray-600 font-mono mt-1">{user.id}</div>
          </div>
          <div className="border-b border-gray-100 pb-2">
            <div className="overline">Membre depuis</div>
            <div className="text-sm text-gray-800 mt-1">
              {user.created_at ? new Date(user.created_at).toLocaleDateString("fr-FR") : "—"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
